import { render, staticRenderFns } from "./RegisterPage.vue?vue&type=template&id=34bac176&"
import script from "./RegisterPage.vue?vue&type=script&lang=js&"
export * from "./RegisterPage.vue?vue&type=script&lang=js&"
import style0 from "./RegisterPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports